<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <div
        v-if="loading"
        class="pa-5"
      >
        <v-skeleton-loader
          :loading="loading"
          type="avatar, heading, sentences, sentences, sentences, sentences"
          elevation="0"
        >
          <v-list-item
            lines="two"
            subtitle="Subtitle"
            title="Title"
            rounded
          />
        </v-skeleton-loader>
      </div>
      <div v-else>
        <br>
        <div class="d-flex align-center flex-column text-center">
          <v-icon
            size="80"
            color="#37474F"
          >
            mdi-sitemap
          </v-icon>
          <h2>
            {{ projectName }}
          </h2>
          <p class="indication">
            <v-icon
              color="#000"
              x-small
            >
              mdi-wrench-outline
            </v-icon> Indicates
            Issue |
            <v-icon
              color="#000"
              x-small
            >
              mdi-account-hard-hat
            </v-icon> Indicates
            Work
          </p>
        </div>
        <div
          v-if="anyProjectActivitiesAvailable"
          class="pa-2"
        >
          <br>
          <v-card
            v-for="(item, index) in appUserProjectActivities"
            :key="index"
            small
            color="transparent"
            class="box"
            elevation="0"
          >
            <v-row>
              <v-col>
                <div class="container-box">
                  <div class="box-2">
                    <v-card-text>
                      <p
                        class="title-text-style"
                      >
                        {{ item.app_user.first_name }} {{ item.app_user.last_name }}
                      </p>
                      <div class="d-flex justify-space-between">
                        <div v-if="item.type === 'worker'">
                          <!-- <p
                            v-if="item.work_details === null"
                            class="title-text-style"
                          >
                            Check-in Item:
                            <font class="value-text-style">
                              N/A
                            </font>
                          </p> -->
                          <p
                            v-if="item.work_details && item.work_details.issue"
                            class="title-text-style"
                          >
                            Check-in Item:
                            <font class="value-text-style">
                              {{ item.work_details.issue.title }}
                            </font>
                            <v-icon
                              color="#000"
                              small
                            >
                              mdi-wrench-outline
                            </v-icon>
                          </p>
                          <p
                            v-if="item.work_details && item.work_details.budget"
                            class="title-text-style"
                          >
                            Check-in Item:
                            <font class="value-text-style">
                              {{ item.work_details.budget.name }}
                            </font>
                            <v-icon
                              color="#000"
                              small
                            >
                              mdi-account-hard-hat
                            </v-icon>
                          </p>
                          <p class="title-text-style">
                            Type:
                            <font
                              class="value-text-style capitalizeFirstLetter"
                            >
                              {{ item.type }}
                            </font>
                          </p>
                        </div>
                        <div v-if="item.type === 'contractor'">
                          <p class="title-text-style">
                            Contract:
                            <font class="value-text-style">
                              {{ item.contract_details.contract.name }}
                            </font>
                          </p>
                          <p class="title-text-style">
                            Type:
                            <font class="value-text-style">
                              {{ item.type | capitalizeFirstLetter }}
                            </font>
                          </p>
                        </div>
                        <div
                          v-if="
                            item.type === 'staff' || item.type === 'visitor'
                          "
                        >
                          <!-- <p class="title-text-style">
                            Check-in Item:
                            <font class="value-text-style">
                              N/A
                            </font>
                          </p> -->
                          <p class="title-text-style">
                            Type:
                            <font
                              class="value-text-style capitalizeFirstLetter"
                            >
                              {{ item.type | arrangeSiteManager }}
                            </font>
                          </p>
                        </div>
                        <v-chip
                          dark
                          rounded
                          outlined
                          color="#e6e6e6"
                          x-small
                          elevation="0"
                        >
                          <v-icon x-small>
                            mdi-account-clock
                          </v-icon>&nbsp;
                          {{ item.total_hours }} Hrs
                        </v-chip>
                      </div>
                      <div class="time-style">
                        <p>
                          <v-icon
                            color="green"
                            size="18"
                          >
                            mdi-update
                          </v-icon>
                          <font
                            class="date-style"
                            style="text-transform: uppercase"
                          >
                            {{ item.checkin_time | convertToLocal }}
                          </font>
                        </p>
                        <p v-if="item.checkout_time !== null">
                          <v-icon
                            color="red"
                            size="18"
                          >
                            mdi-history
                          </v-icon>
                          <font
                            class="date-style"
                            style="text-transform: uppercase"
                          >
                            {{ item.checkout_time | convertToLocal }}
                          </font>
                        </p>
                        <p v-else>
                          <v-icon
                            color="red"
                            size="18"
                          >
                            mdi-history
                          </v-icon>
                          <font class="date-style active-color">
                            Onsite*
                          </font>
                        </p>
                      </div>
                    </v-card-text>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
          <br>
          <div class="text-center">
            <v-progress-circular
              v-if="lazyLoader"
              size="25"
              :width="2"
              color="#e2e2e2"
              indeterminate
            />
          </div>
          <div
            ref="observer"
            class="observer"
          />
        </div>
        <div
          v-else
          class="empty-alert-div pt-5"
        >
          <v-card
            color="#FFF"
            elevation="0"
          >
            <br>
            <br>
            <br>
            <p class="empty-alert-msg">
              <v-icon
                size="25"
                color="#C62828"
              >
                mdi-information-outline
              </v-icon>
              No records found
            </p>
            <br>
            <br>
          </v-card>
        </div>
      </div>

      <v-btn
        fab
        color="#FFF"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
    </div>
  </v-dialog>
</template>
<script>
import moment from 'moment';
export default {
  name: 'AppUserProjectActivities',
  components: {},
  filters: {
    arrangePretty (val) {
      if (val !== undefined) {
        return val.join(', ');
      }
    },
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('DD/MM/YY h:mm A');
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    arrangeSiteManager (val) {
      if (val === 'staff') {
        return 'Site Manager';
      } else {
        return val;
      }
    },
  },
  props: {
    orgExtId: {
      type: String,
      default: null,
    },
    projectId: {
      type: String,
      default: null,
    },
    projectName: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      showModal: true,
      loading: false,
      startPage: 0,
      lazyLoader: false,
    };
  },
  computed: {
    appUserProjectActivities () {
      return this.$store.getters['projects/getAppUserProjectActivities'];
    },
    anyProjectActivitiesAvailable () {
      return this.appUserProjectActivities.length !== 0;
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    this.loading = true;
    await this.clearAllData();
    await this.getAppUserProjectActivities();
    await this.loadMore();
    this.loading = false;
  },
  methods: {
    async getAppUserProjectActivities () {
      await this.$store.dispatch('projects/fetchAppUserProjectActivity', {
        orgExtId: this.orgExtId,
        projectId: this.projectId,
        params: {
          params: {
            startPage: this.startPage,
            limit: 10,
          },
        },
      });
      this.loading = false;
    },
    async clearAllData () {
      this.$store.dispatch('projects/clearAppUserProjectActivities');
    },
    async loadMore () {
      if (this.appUserProjectActivities.length === 0) {
        return;
      }
      await this.initObserver();
    },
    initObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };
      this.observer = new IntersectionObserver(this.handleIntersect, options);
      this.observer.observe(this.$refs.observer);
    },
    async handleIntersect (entries) {
      if (entries[0].isIntersecting) {
        this.startPage = this.startPage + 10;
        this.lazyLoader = true;
        await this.getAppUserProjectActivities();
        this.lazyLoader = false;
      }
    },
  },
};
</script>
<style scoped>
.btns {
  position: absolute;
  top: 0;
  right: 0;
  gap: 10px;
  display: flex;
}

.box {
  border-radius: 0px !important;
  padding: 0px !important;
}
.box-2 {
  width: 100% !important;
  border-radius: 10px;
  background: #FFF;
}

.v-skeleton-loader--is-loading {
  margin-top: 20px;
}

.v-skeleton-loader >>> .v-skeleton-loader__table-heading {
  background: transparent !important;
}

.v-skeleton-loader >>> .v-skeleton-loader__avatar {
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 100px;
}

.v-skeleton-loader >>> .v-skeleton-loader__heading {
  left: 50%;
  transform: translateX(-50%);
  margin-top: 15px;
}

.v-skeleton-loader >>> .v-skeleton-loader__article {
  background: transparent !important;
}

.v-skeleton-loader >>> .v-skeleton-loader__avatar,
.v-skeleton-loader >>> .v-skeleton-loader__text,
.v-skeleton-loader >>> .v-skeleton-loader__heading {
  background-color: #eceff1 !important;
}

.v-skeleton-loader >>> .v-skeleton-loader__text {
  margin-top: 20px;
}

.observer {
  height: 40px;
}

.time-style {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
p {
  margin-bottom: 12px !important;
}
.capitalizeFirstLetter {
  text-transform: capitalize;
}
.date-style {
  color: black;
  font-size: 12px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  text-transform: capitalize;
}
.indication {
  font-size: 13px;
  font-style: italic;
}
.active-color {
  color: #2e7d32;
}
</style>
